import { render, staticRenderFns } from "./sprinklr.vue?vue&type=template&id=689ad19c"
import script from "./sprinklr.vue?vue&type=script&lang=js"
export * from "./sprinklr.vue?vue&type=script&lang=js"
import style0 from "./sprinklr.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports